import { render, staticRenderFns } from "./DialogViewAttachment.vue?vue&type=template&id=f24cdfe8"
import script from "./DialogViewAttachment.js?vue&type=script&lang=js&external"
export * from "./DialogViewAttachment.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports